import {
  Box,
  Text,
  WrapItem,
  Image,
  Link,
  Button
} from "@chakra-ui/react";
import { useRef } from "react";
import GithubCalendar from "../Components/githubCalander";
import Contact from "../Components/contact";
import GithubStats from "../Components/githubStats";
import Navbar from "../Components/Navbar";
import Project1 from "../Components/Project1";
import Project2 from "../Components/Project2";
import Project3 from "../Components/Project3";
import Project4 from "../Components/Project4";
import Resume from "../Components/resume";
import Skills from "../Components/Skills";
import "./style.css";

function Home() {
  const aboutsec = useRef(null);
  const projectsec = useRef(null);
  const skillssec = useRef(null);
  const contactSec = useRef(null);
  const ResumeSec = useRef(null);

  const handleAbout = () =>
    window.scrollTo({
      top: aboutsec.current.offsetTop,
      behavior: "smooth",
    });

  const handleProjects = () =>
    window.scrollTo({
      top: projectsec.current.offsetTop,
      behavior: "smooth",
    });

  const handleSkills = () =>
    window.scrollTo({
      top: skillssec.current.offsetTop,
      behavior: "smooth",
    });

  const handleContact = () =>
    window.scrollTo({
      top: contactSec.current.offsetTop,
      behavior: "smooth",
    });

  const handleResume = () =>
    window.scrollTo({
      top: ResumeSec.current.offsetTop,
      behavior: "smooth",
    });

  return (
    <>
      <Box  id="nav-menu" pt={3}>
        <Navbar
          handleAbout={handleAbout}
          handleProjects={handleProjects}
          handleResume={handleResume}
          handleSkills={handleSkills}
          handleContact={handleContact}
        />
      </Box>
      <Box
       id="home"
        mt={"-135px"}
        maxWidth="container.xxl"
        pb={"1%"}
        color={"white"}
        pt={{base:"80px",md:"100px",lg:"180px"}}
        backgroundImage={
          "radial-gradient(circle at 10% 20%, rgb(0, 0, 0) 0%, rgb(64, 64, 64) 90.2%)"
        }
        fontFamily={"Helvetica"}
        fontSize={20}
      >
        <Box display={{ lg: "flex" }} maxW={"80%"} m={"auto"} mt={"180px"}>
          <Box>
            <Text fontSize={{ base: "20px", md: "30px", lg: "50px" }}>
              Hello 👋
            </Text>
            <Text id="user-detail-name" fontSize={{ base: "20px", md: "30px", lg: "50px" }}>
              I'm Imran an Aspiring Full Stack Web Developer.
            </Text>
          </Box>
          <Image
            className="home-img"
            w={{ base: "200px", md: "200px", lg: "500px" }}
            margin={"auto"}
            mt={{ base: "70px", md: "70px", lg: "0px" }}
            name="Imran"
            borderRadius="50%"
            src="https://avatars.githubusercontent.com/u/107936528?v=4"
            
          />
        </Box>
        <Box>
          <Box ref={aboutsec} pt={20} mt={30} textAlign={"center"}>
            <Text
              color={"#FFB6C1"}
              textDecoration={"underline"}
              fontSize={{ base: "30px", md: "45px", lg: "60px" }}
            >
              About Me
            </Text>
            <WrapItem mt={10}></WrapItem>
          </Box>
        </Box>
        <Box  id="about" class="about section" m={"auto"} w={"80%"} mt={10}>
          <Text
           id="user-detail-intro"
            fontSize={{ base: "20px", md: "30px", lg: "40px" }}
            textAlign={"center"}
          >
            My name's Imran. I'm an enthusiastic full-stack web developer with
            hands-on experience. in creating websites with MERN Stack. I'm an
            eager learner of new technologies. I'm excited to join a tech
            company as an accountable a capable employee.
          </Text>
          <Box
            mb={"50px"}
            pt={"40px"}
            textAlign={"center"}
            fontSize={{ base: "15px", md: "20px", lg: "30px" }}
          >
            <h1>Click here to download Resume</h1>
          </Box>
          <Box
            borderRadius={"70px"}
            margin={"auto"}
            border={"10px solid #FFB6C1"}
            w={{ base: "200px", md: "260px", lg: "320px" }}
          >
            <Link  id="resume-link-2" href="https://drive.google.com/uc?export=download&id=1JtdLZiel62sPDZoK5rHsn1Nfpfy9A4kN">
              <Button
                w={{ base: "180px", md: "240px", lg: "300px" }}
                mt={"50px"}
                display={"flex"}
                justifyContent={"center"}
                margin="auto"
                alignItems={"center"}
                backgroundColor={"white"}
                color={"black"}
                h={{ base: "60px", md: "80px", lg: "100px" }}
                borderRadius={"70px"}
                _hover={"none"}
              >
                Download
              </Button>
            </Link>
          </Box>
        </Box>
        <Box pt={"25px"} ref={projectsec}>
          <Box mb={"30px"} textAlign="center">
            <Text
              color={"#FFB6C1"}
              mt={20}
              textDecoration={"underline"}
              fontSize={{ base: "30px", md: "45px", lg: "60px" }}
            >
              Projects
            </Text>
          </Box>
          <Box  id="projects">
            <Project4 />
            <Project1 />
            <Project3 />
            <Project2 />
          </Box>
        </Box>

        <Box id="skills" pt={"25px"} ref={skillssec} mb={"60px"} textAlign="center">
          <Skills />
        </Box>

        <GithubCalendar />
        <GithubStats />

        <Box pt={"25px"} ref={ResumeSec}>
          <Resume />
        </Box>
        <Box  id="contact" ref={contactSec}>
          <Contact />
        </Box>
      </Box>
    </>
  );
}

export default Home;
